document.addEventListener("DOMContentLoaded", (event) => {
  const spaceBetween = 0; 
  const swiper = new Swiper('.tagSwiper', {
    a11y: {
      enabled: false
    },
    centeredSlides: false,
        slidesPerView: 'auto',
        cssMode: true,
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        spaceBetween: spaceBetween,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
       breakpoints: {
        360: {
            spaceBetween: spaceBetween,
          slidesPerView: 1.2,
        },
        640: {
            spaceBetween: spaceBetween,
          slidesPerView: 1.2,
        },
        768: {
          spaceBetween: spaceBetween,
           slidesPerView: 2.6,
        },
        1024: {
          spaceBetween: spaceBetween,
           slidesPerView: 'auto',
        },
      },
  });
});
